import React from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";
import {AgGridReact as Grid, AgGridColumn as Col} from "ag-grid-react";

import {DateRenderer} from "../../../components";
import {caseInsensitiveNameComparator} from "../../../utils";

const Container = styled.div`
    width: 100%;
    height: 425px;
`;

class NFSampleDataGrid extends React.Component {
  onGridReady = ({api}) => api.sizeColumnsToFit();

  render() {
    return (
      <Container className='ag-fresh'>
        <Grid
          rowData={this.props.patients}
          onGridReady={this.onGridReady}
          rowHeight={35}
          headerHeight={35}
          pagination={true}
          enableFilter={false}
          enableSorting={false}
          enableColResize={false}
          suppressMovableColumns={true}
          paginationPageSize={this.props.pageSize}
          defaultColDef={{filterParams: {newRowsAction: 'keep'}}}
          columnTypes={{
            actionsColumn: {suppressMenu: true, suppressSorting: true}
          }}
          frameworkComponents={{
            dateRenderer: DateRenderer,
            actionsRenderer: this.props.actionsRenderer
          }}
        >
          <Col
            width={125}
            sort="asc"
            comparator={caseInsensitiveNameComparator}
            headerName="Patient Name"
            field="name"
          />
          <Col
            width={50}
            headerName="Medicaid ID"
            field="medicaidId"
          />
          <Col
            width={50}
            headerName="DOB"
            field="dateOfBirth"
            cellRenderer="dateRenderer"
          />
          <Col
            width={50}
            headerName="Admit Date"
            field="admissionDate"
            cellRenderer="dateRenderer"
          />
          <Col
            width={85}
            headerName="Review Status"
            field="recordStatus"
          />
          <Col
            width={50}
            headerName="Actions"
            type="actionsColumn"
            cellRenderer="actionsRenderer"
          />
        </Grid>
      </Container>
    )
  }
}

NFSampleDataGrid.propTypes = {
  patients: PropTypes.array.isRequired,
  actionsRenderer: PropTypes.func.isRequired,
};

export default NFSampleDataGrid;



// WEBPACK FOOTER //
// ./src/modules/sample/components/NFSampleDataGrid.js